import alt from "../alt";

class OrderActions {
  constructor() {
    this.generateActions(
      "newOrderFlow",
      "startOrderSubmission",
      "submitOrder",
      "updateCurrentOrder",
      "orderSucceeded",
      "orderCompleted",
      "orderFailed",
      "updateOrders",
      "fetchAll",
      "fetchOne",
      "fetchFailed",
      "downloadReceipt",
      "dropReservedSeats",
      "pushCurrentOrderToCart",
      "resetCart",
      "newCartOrderFlow",
      "updateCart"
    );
  }

  updateOrder(id, order) {
    return { id, order };
  }
}

export default alt.createActions(OrderActions);



// WEBPACK FOOTER //
// ./src/app/actions/OrderActions.js